<div class="sub-skill-dialog">
    <div class="dialog-header">
        <div class="header-title">
            <h2>{{ data.topic }}</h2>
        </div>
        <button class="btn-close" (click)="closeDialog()">
            <span class="close-icon">&times;</span>
        </button>
    </div>
    <div class="dialog-body">
        <div class="description-section">
            <label class="section-label">Description</label>
            <p class="description-text">{{ data.description }}</p>
        </div>
    </div>
    <div class="dialog-footer">
        <button class="btn-done" (click)="closeDialog()">Close</button>
    </div>
</div>
